import { Component, Input, OnInit } from '@angular/core';
import { ContentConfigOption } from '../../content-config-option';
import { FormGroup } from '@angular/forms';
import { ContentConfigOptionType } from '../../content-config-option-type';

@Component({
  selector: 'configure-content-container-option-form',
  template: `<div [formGroup]="form" [ngSwitch]="option.type">

  <!-- Type: Text -->
  <mat-form-field *ngSwitchCase="'text'">
    <input matInput type="text" [formControlName]="option.key" [placeholder]="option.name" />
    <mat-hint *ngIf="option.hint">{{option.hint}}</mat-hint>
    <mat-error *ngIf="!isValid">
      <div *ngIf="errors.required">{{option.name}} is required!</div>
    </mat-error>
  </mat-form-field>

  <!-- Type: Number -->
  <mat-form-field *ngSwitchCase="'number'">
    <input matInput type="number" [formControlName]="option.key" [placeholder]="option.name" />
    <mat-hint *ngIf="option.hint">{{option.hint}}</mat-hint>
    <mat-error *ngIf="!isValid">
      <div *ngIf="errors.required">{{option.name}} is required!</div>
    </mat-error>
  </mat-form-field>

  <!-- Type: Boolean -->
  <div class="mat-form-field-infix" *ngSwitchCase="'boolean'">
    <mat-checkbox type="checkbox" [formControlName]="option.key">{{option.name}}</mat-checkbox>
  </div>

  <!-- Type: Select -->
  <mat-form-field *ngSwitchCase="'select'">
    <mat-select [formControlName]="option.key" [placeholder]="option.name">
      <mat-option *ngFor="let subOption of option.options" [value]="subOption.value">{{subOption.name}}</mat-option>
    </mat-select>
    <mat-hint *ngIf="option.hint">{{option.hint}}</mat-hint>
    <mat-error *ngIf="!isValid">
      <div *ngIf="errors.required">{{option.name}} is required!</div>
    </mat-error>
  </mat-form-field>
</div>`,
  styles: [`.mat-input-container{width:100%}`]
})
export class ConfigureContentContainerOptionFormComponent {
  @Input() option: ContentConfigOption;
  @Input() form: FormGroup;

  public get isValid() { return this.form.controls[this.option.key].valid; }
  public get errors() { return this.form.controls[this.option.key].errors; }

  public get items(): any[] {
    switch (this.option.type) {
      case ContentConfigOptionType.boolean:
        return [{ name: this.option.name, value: true }];
      default:
        return [];
    }
  }

  public get value(): any {
    switch (this.option.type) {
      case ContentConfigOptionType.boolean:
        return !!((this.form.value[this.option.key] || [])[0]);
      default:
        return this.form.value[this.option.key];
    }
  }

}
